<div
	@fadeInOut
	class="fixed inset-0 z-50 flex items-center justify-center bg-peps-dark-900/50"
	(click)="onBackgroundClick($event)"
>
	<div
		@scaleInOut
		class="h-full w-full bg-peps-dark-700 relative p-8 md:h-fit xl:w-8/12 overflow-y-scroll custom-vertical-scrollbar"
	>
		<div class="flex flex-row items-center gap-2 w-fit">
			<img src="assets/images/team_peps_logo.avif" alt="Team Peps" class="h-10" />
			<span class="uppercase text-2xl">{{ 'component.place-leaderboard.title' | translate }}</span>

		</div>
		<button
			class="absolute top-4 right-4 text-peps-dark-200 hover:text-white transition cursor-pointer"
			(click)="closeLeaderboardModal()">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-10">
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
			</svg>
		</button>

		<div class="flex flex-col gap-4 p-6 md:row-start-2 md:col-span-2 mt-2 max-h-full md:max-h-96 overflow-y-scroll custom-vertical-scrollbar">
			<table
				class="min-w-[300px] w-full max-w-full text-sm font-notosans border-separate border-spacing-y-2"
			>
				<thead>
				<tr class="text-peps-dark-200/60 uppercase text-xs">
					<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-left">{{ 'page.place-leaderboard.rank' | translate }}</td>
					<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-left min-w-[140px]">{{ 'page.place-leaderboard.username' | translate }}</td>
					<td class="px-4 py-2 text-right">{{ 'page.place-leaderboard.pixels' | translate }}</td>
				</tr>
				</thead>
				<tbody>
					@for(leaderboard of leaderboard(); track leaderboard.username; let i = $index) {
						<tr class="w-full bg-peps-dark-600 text-peps-dark-200/90">
							<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-peps-dark-200/80">
								<div class="flex flex-row gap-2 items-center">

									<span>{{ currentPage() * 20 + i + 1 }}</span>
								</div>
							</td>
							<td class="px-2 py-1.5 lg:px-6 lg:py-3 text-left" [ngClass]="{'text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]': currentUsername === leaderboard.username }">
								{{ leaderboard.username }}
							</td>
							<td class="px-4 py-3 text-right font-medium transition-transform duration-200">
								<span class="font-notosans">
									<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)] text-lg">
										{{ leaderboard.pixelsPlaced }}
									</span>
								</span>
							</td>

						</tr>
					}
				</tbody>
			</table>
		</div>

		<peps-page-selector
			[page]="currentPage()"
			[totalPages]="totalPage()"
			(pageChange)="onPageChange($event)"
			[goToTop]="false"
		></peps-page-selector>
	</div>
</div>
